<template>
    <main-content with_go_back_bar>
        <kt-panel>
            <kt-panel-body >
                <form class="kt-form" @submit.prevent="update" >
                    <kt-form-section>
                        <kt-form-row>
                            <kt-col lg="4" md="4" sm="12">
                                <kt-form-group>
                                    <kt-form-label for="national_code">
                                        {{ $t('label.new_password') }}
                                    </kt-form-label>
                                    <kt-form-control
                                        dir="ltr"
                                        type="password"
                                        name="new_password"
                                        id="new_password"
                                        autocomplete="off"
                                    ></kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col lg="4" md="4" sm="12">
                                <kt-form-group>
                                    <kt-form-label for="national_code">
                                        {{ $t('label.confirm_new_password') }}
                                    </kt-form-label>
                                    <kt-form-control
                                        dir="ltr"
                                        type="password"
                                        name="new_password_confirm"
                                        id="new_password_confirm"
                                        autocomplete="off"
                                    ></kt-form-control>
                                </kt-form-group>
                            </kt-col>
                        </kt-form-row>
                    </kt-form-section>

                    <kt-form-action class="mt-4">
                        <button class="btn btn-md btn-success btn-wide" type="submit" id="submit_btn">
                            {{ $t('btn.submit') }}
                        </button>
                    </kt-form-action>
                </form>
            </kt-panel-body>
        </kt-panel>
    </main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import $ from 'jquery'
import { KTApp } from '@/plugins/core/app'
import { KTUtil } from '@/plugins/core/util'
import { userService } from '@/common/api.service'
import {mapGetters} from "vuex";
import Vue from "vue";

export default {
    name: 'change_user_password',
    components: {
        'main-content': mainContent,
    },
    computed: {
        ...mapGetters('user', [
            'current_user'
        ])
    },
    methods: {
        update(e) {
            let form = $(e.target)
            let btn = $('#submit_btn')

            form.validate({
                ignore: ":hidden",

                rules: {
                    new_password : {
                        required: true,
                        minlength : {
                            param: 6
                        }
                    },
                    new_password_confirm : {
                        required: true,
                        equalTo : "#new_password"
                    }
                },
            });

            if(!form.valid()) {
                return
            }

            let params = {
                new_password: $('#new_password').val(),
                user_hashid: this.$route.params.hashid,
            }

            KTApp.progress(btn)
            userService.changeUserPassword(params, this.current_user.id)
                .then(response => {
                    Vue.prototype.$axios.defaults.headers.common['admin-id'] = 'null'
                    // this.$store.commit('user/success', response.data.data)
                    this.showMsg(form, 'success', response.data.message)

                })
                .catch(({response}) => {
                    Vue.prototype.$axios.defaults.headers.common['admin-id'] = 'null'
                    if(response.data) {
                        form.validate().showErrors(response.data.data)
                    }
                    this.showMsg(form, 'danger', response.data.message)
                })
                .finally(() => {
                    KTUtil.scrollTop()
                    KTApp.unprogress(btn)
                    $("#new_password").val('')
                    $("#new_password_confirm").val('')
                })
        },
    }
}

</script>